module.exports = __webpack_public_path__ + "img/apnaklub-icon.02389ad9.png";